import Image from "next/image";
import React from "react";

const CardsSliderCard = ({ index, title, img, description }) => {
  return (
    <div className="facilities-card _eleX" key={index}>
      <div className="img-container">
        {img && <Image src={img} alt="card" layout="fill" objectFit="cover" />}
      </div>
      {/* {title && (
        <div className="title bold">
          <h4>{title}</h4>
        </div>
      )} */}
      {description && (
        <div className="description">
          <p dangerouslySetInnerHTML={{ __html: description?.replace(/360 works/i, '<span class="works_360">360 works</span>') }} />
        </div>
      )}
    </div>
  );
};

export default CardsSliderCard;
